import Vue from 'vue';
import { api } from "../../services/Api.js";

export function send_contact_form({ state }, payload ){

    // adding token
    payload.token=state.appSettings.token

    // get active school
    var school = state.user_schools.find(school => school.active === 1);
    

    return new Promise((resolve)=>{
    // make api call
    api
      .post(school,"send_form.php",payload)
      .then( () =>{ 
       
        resolve();
      })
      .catch( error => {
        
        Vue.$toaster.toast("store: send_contact_form: "+error);
      })

    });// promise
    
  }